import type { MonitioAPI } from "@root/types.api.local";
import type { AxiosInstance } from "axios";

export default (axios: AxiosInstance) => ({
  impersonate(id: string) {
    return axios.put(`/v1/auth/impersonate/${id}`);
  },
});
